<template>
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0" >#</th>
        <th scope="col" class="text-left border-0">Nome</th>
        <th scope="col" class="text-left border-0">Preço</th>
        <th scope="col" class="text-left border-0">Opções</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(service, index) in services" :key="index">
        <td>{{ service.id }}</td>
        <td class="text-left">
         <d-link :to="{ name: 'admin-service-edit', params: { serviceId: service.id } }">{{ service.name }}</d-link>
        </td>
        <td class="text-left">{{ service.price }}</td>
        <td class="text-right">
            <d-button-group class="buttons">
              <d-button size="sm" class="btn-danger" @click.prevent="confirmDeleteRow(service.id)">
                <i class="fas fa-trash"></i><span class="d-none d-lg-inline"> Deletar</span>
              </d-button>
            </d-button-group>
        </td>
      </tr>
      <tr v-if="services.length === 0">
        <td colspan="4" class="no-content">Ainda não foi cadastrado nenhum serviço.</td>
      </tr>
    </tbody>
    <confirmation-modal
      :cancel="close"
      :confirm="deleteRow"
      title="Confirme exclusão do serviço"
      message="Tem certeza que deseja excluir esse serviço?"/>
  </table>
</template>

<script>
import { mapActions } from 'vuex';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import ServiceService from '_services/rest/modules/service';
import Events from '_utils/events';

export default {
  name: 'service-table-list',
  components: {
    ConfirmationModal,
    ServiceService,
  },
  props: {
    services: {
      type: Array,
    },
    showProject: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selectedRow: null,
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    checkStatus(service) {
      if (service.status_slug === 'closed') {
        return null;
      }
      return { borderLeftColor: service.color };
    },
    confirmDeleteRow(id) {
      this.setToggle({ type: 'confirm_modal', bool: true });
      this.selectedRow = id;
    },
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    deleteRow() {
      this.setToggle({ type: 'progress', bool: true });
      ServiceService.deleteService(this.selectedRow)
        .then(() => {
          this.close();
          this.$router.push({ name: 'admin-service-list', params: { page: 1 } }).catch(() => { });
          Events.$emit('update:pagination', false);
          this.activeAlert({ message: 'Service deletado com sucesso', theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
  mounted() {
  },
};
</script>
<style lang="scss" scoped>
@import '~_scss/overrides';

.date {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin: 0 auto;
}

$size: 10px;
.border-color {
  border-left: $size solid $red;
  &-new {
    border-left-color: $red;
  }
  &-open {
    border-left-color: $orange;
  }
  &-progress {
    border-left-color: $yellow;
  }
  &-resolved {
    border-left-color: $green;
  }
  &-closed {
    border-left-color: $blue;
  }
}

.color{
  &-new {
    color: $red;
  }
  &-open {
    color: $orange;
  }
  &-progress {
    color: $yellow;
  }
  &-resolved {
    color: $green;
  }
  &-closed {
    color: $blue;
  }
}
.td-3 {
  width: 120px;
}
</style>
